import * as React from 'react'

import useI18n from '@store/i18n/useI18n'
import styled from '@theme/styled-components'

interface Props {
  navigation: Navigation
}

const Tooltip = ({ navigation }: Props) => {
  const [isOpened, setIsOpened] = React.useState(false)
  const i18n = useI18n()

  return (
    <Container>
      <InformationButtonContainer selected={isOpened} onClick={() => setIsOpened(!isOpened)}>
        <InformationButtonLibelle selected={isOpened}>i</InformationButtonLibelle>
      </InformationButtonContainer>
      {isOpened && (
        <InformationContainer>
          {i18n.t('components.adminData.tooltip.content')}
          <GoToLink onClick={() => navigation.navigate('/information')}>
            {i18n.t('components.globalmenu.process.title')}
          </GoToLink>
        </InformationContainer>
      )}
    </Container>
  )
}

export default Tooltip

const Container = styled('div')`
  position: relative;
`

const InformationContainer = styled('div')<{ center?: boolean }>`
  ${(props) => props.theme.fonts.lonelyPictureLibelle}
  display: flex;
  position: absolute;
  align-items: center;
  padding: 10px;
  width: 300px;
  flex-direction: column;
  background: ${(props) => props.theme.colors.filterBackgroundColor};
  box-shadow: 1px 1px 1px 1px #bbbe;
`

const InformationButtonContainer = styled('div')<{ selected: boolean }>`
  display: flex;
  margin-left: 25px;
  cursor: pointer;
  border: 1px solid ${(props) => props.theme.colors.filterPrimarycolor};
  background-color: ${(props) =>
    props.selected ? props.theme.colors.filterPrimarycolor : props.theme.colors.filterSecondaryColor};
  box-sizing: border-box;
  border-radius: ${(props) => (props.selected ? '17px 17px 0 0' : '9999px')};
  ${(props) => props.selected && 'border-bottom-width: 0;'}
  height: 25px;
  width: 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  box-shadow: 1px 1px 1px 1px #bbbe;
`

const InformationButtonLibelle = styled('div')<{ selected: boolean }>`
  ${(props) => props.theme.fonts.lonelyPictureLibelle}
  ${(props) => props.selected && `color: ${props.theme.colors.filterSecondaryColor};`}
  font-weight: bold;
`
const GoToLink = styled('nav')`
  text-decoration: underline;
  color: ${(props) => props.theme.colors.primary_blue};

  &: hover {
    cursor: pointer;
  }
`
